'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contract = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _operation = require('./operation');

var _xdr = require('./xdr');

var _xdr2 = _interopRequireDefault(_xdr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Create a new Contract object.
 *
 * `Contract` represents a single contract in the Stellar network. Contract embodies the interface of the contract. See
 * [Contracts](https://developers.stellar.org/docs/glossary/contracts/) for
 * more information about how contracts work in Stellar.
 *
 * @constructor
 *
 * @param {string} contractId - ID of the contract (ex.
 *     `000000000000000000000000000000000000000000000000000000000000000001`).
 */
// TODO: Support contract deployment, maybe
var Contract = exports.Contract = function () {
  // TODO: Figure out contract owner/id stuff here. How should we represent that?
  function Contract(contractId) {
    _classCallCheck(this, Contract);

    // TODO: Add methods based on the contractSpec (or do that elsewhere?)
    this._id = Buffer.from(contractId, 'hex');
  }

  /**
   * Returns Stellar contract ID as a hex string, ex.
   * `000000000000000000000000000000000000000000000000000000000000000001`.
   * @returns {string}
   */


  _createClass(Contract, [{
    key: 'contractId',
    value: function contractId() {
      return this._id.toString('hex');
    }

    /**
     * @param {string} method - name of the method to call
     * @param {...xdr.ScVal} params - arguments to pass to the function call
     * @returns {xdr.Operation} Build a InvokeHostFunctionOp operation to call the contract.
     */

  }, {
    key: 'call',
    value: function call(method) {
      var contractId = Buffer.from(this._id, 'hex');

      for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      return _operation.Operation.invokeHostFunction({
        function: _xdr2.default.HostFunction.hostFunctionTypeInvokeContract([_xdr2.default.ScVal.scvObject(_xdr2.default.ScObject.scoBytes(contractId)), _xdr2.default.ScVal.scvSymbol(method)].concat(params)),
        // TODO: Figure out how to calculate this or get it from the user?
        footprint: new _xdr2.default.LedgerFootprint({
          readOnly: [_xdr2.default.LedgerKey.contractData(new _xdr2.default.LedgerKeyContractData({
            contractId: contractId,
            key: _xdr2.default.ScVal.scvStatic(_xdr2.default.ScStatic.scsLedgerKeyContractCode())
          }))],
          readWrite: []
        }),
        auth: []
      });
    }
  }]);

  return Contract;
}();